import React from 'react';
import { Button, Card } from 'react-bootstrap';

const SaaSBlocked = () => (
    <div className="d-flex justify-content-center align-items-center min-vh-100 p-3">
        <Card className="text-center shadow-sm" style={{ maxWidth: 520 }}>
            <Card.Body className="p-5">
                <i className="fa-solid fa-lock text-warning display-4 mb-3" />
                <h2>Acesso temporariamente bloqueado</h2>
                <p className="text-muted">Identificamos uma pendência na assinatura da sua empresa. Regularize o pagamento para continuar usando o Colmeia.</p>
                <Button variant="primary" href="mailto:suporte@colmeiabarber.com">Falar com o financeiro</Button>
            </Card.Body>
        </Card>
    </div>
);

export default SaaSBlocked;
